<template>
  <div>
    <hr />
    <div style="margin: 5px 1%; display: flex; align-items: center; justify-content: space-between">
      <div style="display: flex; align-items: center; gap: 15px">
        <AwSelectMenu
          v-if="!disabled"
          :model-value="pageSize"
          :items="items"
          :search-input="false"
          size="sm"
          :disabled="disabled"
          @update:model-value="onPageSizeChange($event)"
        />
        <p>
          {{ pageIndex * pageSize + 1 }}-{{ Math.min((pageIndex + 1) * pageSize, totalItems) }} Résultats (sur
          {{ totalItems }})
        </p>
      </div>
      <div style="display: flex; align-items: center">
        <AwButton
          color="secondary"
          variant="outline"
          size="sm"
          :disabled="pageIndex === 0"
          @click="$emit('update:pageIndex', pageIndex - 1)"
        >
          <AwIcon name="lucide:chevron-left" />
        </AwButton>
        <template v-for="page in pages" :key="page">
          <AwButton
            v-if="typeof page === 'number'"
            color="secondary"
            variant="ghost"
            size="sm"
            :style="getPageButtonStyle(page)"
            @click="$emit('update:pageIndex', page - 1)"
          >
            {{ page }}
          </AwButton>
          <span v-else>...</span>
        </template>
        <AwButton
          color="secondary"
          variant="outline"
          size="sm"
          :disabled="pageIndex >= totalPages - 1"
          @click="$emit('update:pageIndex', pageIndex + 1)"
        >
          <AwIcon name="lucide:chevron-right" style="width: 12px; height: 12px" />
        </AwButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
type Props = {
  totalItems: number;
  pageSize: number;
  pageIndex: number;
  disabled?: boolean;
  items?: number[];
};

const props = withDefaults(defineProps<Props>(), {
  items: () => [20, 40, 60, 80, 100],
});

const emit = defineEmits(["update:pageSize", "update:pageIndex"]);

const onPageSizeChange = (newPageSize: number) => {
  emit("update:pageSize", newPageSize);
  if (props.pageIndex > 0) {
    emit("update:pageIndex", 0);
  }
};

const totalPages = computed(() => Math.ceil(props.totalItems / props.pageSize));

const pages = computed(() => {
  const currentPage = props.pageIndex + 1;
  const total = totalPages.value;

  if (total <= 5) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  if (currentPage <= 3) {
    return [1, 2, 3, "...", total];
  }

  if (currentPage >= total - 2) {
    return [1, "...", total - 2, total - 1, total];
  }

  return [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", total];
});

const getPageButtonStyle = computed(() => (page: number) => ({
  fontWeight: page === props.pageIndex + 1 ? "bold" : "normal",
  textDecoration: page === props.pageIndex + 1 ? "underline" : "none",
  color: page === props.pageIndex + 1 ? "" : "grey",
}));
</script>
